// src/icons/dicerollicon.js
// Icon from Tabler Icons: https://tabler.io/icons/icon/dice-3

import React from 'react';

export default function DiceRollIcon({ size = 32, color = 'currentColor', ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon-tabler icon-tabler-dice-3"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z" />
      <circle cx="8.5" cy="8.5" r=".5" fill={color} />
      <circle cx="12" cy="12" r=".5" fill={color} />
      <circle cx="15.5" cy="15.5" r=".5" fill={color} />
    </svg>
  );
}
